import { render, staticRenderFns } from "./CreationItem.vue?vue&type=template&id=2f90aee3&scoped=true&"
import script from "./CreationItem.vue?vue&type=script&lang=js&"
export * from "./CreationItem.vue?vue&type=script&lang=js&"
import style0 from "./CreationItem.vue?vue&type=style&index=0&id=2f90aee3&prod&scoped=true&lang=css&"
import style1 from "./CreationItem.vue?vue&type=style&index=1&id=2f90aee3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90aee3",
  null
  
)

export default component.exports